import {LocalizationProvider, TimePicker} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DemoItem} from '@mui/x-date-pickers/internals/demo';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import { postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {renderReportfield} from '../../utils/templateUtils';
import './egg_collection_instructions.scss';

export default function Egg(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);

  const [showOtTable, setShowOtTable] = useState(true);

  const [otRows, setOtRows] = useState([
    {parameter: 'New Added in IP List', details: 'NO'},
    {parameter: 'Informed Embryologist', details: 'NO'},
    {parameter: 'Informed Anesthesiologist', details: 'NO'},
    {parameter: 'Type of Sperm', details: ''},
    {parameter: 'Additional Procedure', details: 'Nil'},
    {parameter: 'Sperm Selection Technique', details: 'MF'}
  ]);

  const otHeaders = [
    {key: 'parameter', label: 'PARAMETER', inputType: 'text', readOnly: true},
    {
      key: 'details',
      label: 'DETAILS',
      inputType: 'conditional',
      conditions: {
        'New Added in IP List': {type: 'select', options: ['YES', 'NO']},
        'Informed Embryologist': {type: 'select', options: ['YES', 'NO']},
        'Informed Anesthesiologist': {type: 'select', options: ['YES', 'NO']},
        'Type of Sperm': {type: 'text'},
        'Additional Procedure': {type: 'select', options: ['TESA', 'MTESE', 'Nil']},
        'Sperm Selection Technique': {type: 'select', options: ['MF', 'PICSI', 'Will be decided later']}
      }
    }
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const formatDateInput = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const addDaysToDateInput = (dateValue, days) => {
    const [year, month, day] = dateValue.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);
    return formatDateInput(date);
  };

  const formatDisplayDate = dateValue => dateValue?.split('-').reverse().join('-');

  const getTriggerDate = data => data.trigger_date || data.drug_date_hcg || data.drug_date_15 || data.drug_date_25;

  const handleChange = e => {
    setFormData({...formData, [e.target.name]: e.target.value});

    if (e.target.name === 'nextappointment' || e.target.name === 'nextAppointment') {
      const dateTime = e.target.value.split('T');
      setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: 'Not Visited',
        notes: 'Booking Visit',
        patient_id: patientId
      });
    }

    if (e.target.name === 'trigger_date' || e.target.name === 'drug_date_15' || e.target.name === 'drug_date_25' || e.target.name === 'drug_date_hcg') {
      const triggerDate = e.target.value;
      if (triggerDate) {
        const nextDayStr = addDaysToDateInput(triggerDate, 1);
        setFormData(prev => ({
          ...prev,
          [e.target.name]: triggerDate,
          trigger_date: triggerDate,
          ...(e.target.name === 'trigger_date'
            ? {
                drug_date_15: triggerDate,
                drug_date_25: triggerDate,
                drug_date_hcg: triggerDate
              }
            : {}),
          drug_date_dulcolux: nextDayStr,
          drug_date_indocap: nextDayStr,
          drug_date_pan: nextDayStr
        }));
      }
    }
  };

  const handleOtRowsChange = (id, newRows) => {
    setOtRows(newRows);
    const updatedFormData = {...formData};
    newRows.forEach(row => {
      if (row.parameter === 'New Added in IP List') {
        updatedFormData.newaddediplist5 = row.details;
      } else if (row.parameter === 'Informed Embryologist') {
        updatedFormData.informedembryologist5 = row.details;
      } else if (row.parameter === 'Informed Anesthesiologist') {
        updatedFormData.informedanesthesiologist5 = row.details;
      } else if (row.parameter === 'Type of Sperm') {
        updatedFormData.typeofsperm5 = row.details;
      } else if (row.parameter === 'Additional Procedure') {
        updatedFormData.additionalprocedure5 = row.details;
      } else if (row.parameter === 'Sperm Selection Technique') {
        updatedFormData.spermselectiontechnique5 = row.details;
      }
    });
    setFormData(updatedFormData);
  };

  const handleNillOt = () => {
    setShowOtTable(!showOtTable);
  };

  const handleMuiTimeChange = (e, name) => {
    let hours = e.$H,
      mins = e.$m,
      ampm = 'AM';
    let temMin = e.$m;
    temMin < 10 ? (mins = '0' + temMin) : (mins = temMin);
    if (e.$H >= 12) {
      if (e.$H === 12) {
        hours = 12;
        ampm = 'PM';
      } else {
        let temHour = e.$H - 12;
        temHour < 10 ? (hours = '0' + temHour) : (hours = temHour);
        ampm = 'PM';
      }
    } else if (e.$H === 0) {
      hours = 12;
      ampm = 'AM';
    } else {
      let temHour = e.$H;
      temHour < 10 ? (hours = '0' + temHour) : (hours = temHour);
      ampm = 'AM';
    }

    setFormData({...formData, [name]: `${hours}-${mins}-${ampm}`});
  };

  const renderMuiTime = name => {
    return (
      <div className={!show ? 'show' : 'hide'}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoItem>
            <TimePicker onChange={e => handleMuiTimeChange(e, name)} />
          </DemoItem>
        </LocalizationProvider>
      </div>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center', padding: '5px'}} = options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center', padding: '5px', fontWeight: 'bold'}} = options;
    return <th style={style}>{value}</th>;
  };

  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '30px',
        display: 'flex',
        alignItems: 'center',
        height: '20px',
        marginRight: '5px'
      }}>
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: 'hidden',
        fontSize: '30px',
        lineHeight: '20px'
      }}>
      ●
    </span>
  );

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('eggCollectReportGenerateWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Egg Collection Instructions'
            }
          };


          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const getDrugRow = (drug, genericName, dose, route, TimeComponent, DateComponent) => (
    <tr>
      {renderTableTD(drug)}
      {renderTableTD(genericName)}
      {renderTableTD(dose)}
      {renderTableTD(route)}
      <td style={{textAlign: 'center', padding: '5px', border: '1px solid black'}}>{TimeComponent}</td>
      <td style={{textAlign: 'center', padding: '5px', border: '1px solid black'}}>{DateComponent}</td>
    </tr>
  );

  return (
    <div id='Egg'>
      <div className='Egg'>
        <div style={{width: '100%', display: 'block'}}>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}} alt='Header' />
          </div>
          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>

        <div className='detail'>
          <h3 style={{textAlign: 'center', textDecoration: 'underline', margin: '20px 0'}}>Instructions for Egg Collection – ASCAS</h3>

          <div className='bulletin'>
            <h4 style={{fontWeight: 600}}>Admission Details</h4>
            <div className='row'>
              <div className='col-md-4 d-flex align-items-center mb-2'>
                <ReportFormInputWithLabel label='Time of Admission:' name='admissiondate5' value={formData.admissiondate5} onChange={handleChange} type='date' inputClassName='show' />
              </div>
              <div className='col-md-4 d-flex align-items-center mb-2'>
                <label style={{fontWeight: '600', marginRight: '10px'}}>Time:</label>
                {renderMuiTime('admissiontime5')}
                <span className={show ? 'show' : 'hide'}>{formData.admissiontime5}</span>
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Place:' name='admissionplace5' value={formData.admissionplace5} onChange={handleChange} inputClassName='show' />
              </div>
            </div>

            <p className='mt-2' style={{fontWeight: 600}}>
              Inform: Dr. Aishwarya Parthasarathy at the time of admission
            </p>
          </div>

          <div className='bulletin mt-4'>
            <h4 style={{fontWeight: 600}}>Procedure Details</h4>
            <div className='row'>
              <div className='col-md-4 d-flex align-items-center mb-2'>
                <ReportFormInputWithLabel label='Time of Egg Collection:' name='proceduredate5' value={formData.proceduredate5} onChange={handleChange} type='date' inputClassName='show' />
              </div>
              <div className='col-md-4 d-flex align-items-center mb-2'>
                <label style={{fontWeight: '600', marginRight: '10px'}}>Time:</label>
                {renderMuiTime('proceduretime5')}
                <span className={show ? 'show' : 'hide'}>{formData.proceduretime5}</span>
              </div>
            </div>
          </div>

          <div className='bulletin mt-4'>
            <h4 style={{fontWeight: 600}}>Stimulation Summary</h4>
            <h5 className='mt-2' style={{fontWeight: '600'}}>
              Hormone Levels on Trigger Day:
            </h5>
            <div className='row mb-2'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Trigger Date:' name='trigger_date' value={getTriggerDate(formData)} onChange={handleChange} type='date' inputClassName='show' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='E2:' name='e25' value={formData.e25} onChange={handleChange} endLabel='pg/ml' inputClassName='show' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='LH:' name='lh5' value={formData.lh5} onChange={handleChange} endLabel='mIU/mL' inputClassName='show' />
              </div>
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='P4:' name='p45' value={formData.p45} onChange={handleChange} endLabel='ng/ml' inputClassName='show' />
              </div>
            </div>
          </div>

          {/* Trigger Injection Details Table */}
          <div className='bulletin mt-4'>
            <h4 style={{fontWeight: 600}}>Trigger Injection Details</h4>
            <table className='table_1' border='1' cellSpacing='0' style={{width: '100%'}}>
              <thead>
                <tr>{['Drug', 'Generic Name', 'Dose', 'Route', 'Time', 'Date'].map(th => renderTableTH(th))}</tr>
              </thead>
              <tbody>
                {getDrugRow(
                  'Inj. Ovitrelle',
                  'Choriogonadotropin alfa (recombinant hCG)',
                  '250 mcg',
                  'SC',
                  <>
                    {' '}
                    {renderMuiTime('drug_time_15')} <span className={show ? 'show' : 'hide'}>{formData.drug_time_15}</span>{' '}
                  </>,
                  <>
                    {' '}
                    <input type='date' name='drug_date_15' value={formData.drug_date_15 || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_15}</span>{' '}
                  </>
                )}
                {getDrugRow(
                  'Inj. Decapeptyl',
                  'Triptorelin (GnRH agonist)',
                  '0.2/0.3/0.4 mg',
                  'SC',
                  <>
                    {' '}
                    {renderMuiTime('drug_time_25')} <span className={show ? 'show' : 'hide'}>{formData.drug_time_25}</span>{' '}
                  </>,
                  <>
                    {' '}
                    <input type='date' name='drug_date_25' value={formData.drug_date_25 || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_25}</span>{' '}
                  </>
                )}
                {getDrugRow(
                  'T. Dulcolax',
                  'Bisacodyl',
                  '2 tabs',
                  'Oral',
                  '8:00 AM',
                  <>
                    {' '}
                    <input type='date' name='drug_date_dulcolux' value={formData.drug_date_dulcolux || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_dulcolux}</span>{' '}
                  </>
                )}
                {getDrugRow(
                  'T. Indocap',
                  'Indomethacin',
                  '1-0-1',
                  'Oral (after food)',
                  '9:00 AM – 9:00 PM',
                  <>
                    {' '}
                    <input type='date' name='drug_date_indocap' value={formData.drug_date_indocap || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_indocap}</span>{' '}
                  </>
                )}
                {getDrugRow(
                  'Tab. Pan 40',
                  'Pantoprazole',
                  '40 mg',
                  'Oral (before food)',
                  '1-0-1',
                  <>
                    {' '}
                    <input type='date' name='drug_date_pan' value={formData.drug_date_pan || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_pan}</span>{' '}
                  </>
                )}
                {getDrugRow(
                  'Inj. HCG',
                  'Human Chorionic Gonadotropin (urinary gonadotropin)',
                  '2000 / 5000 IU',
                  'IM / SC',
                  <>
                    {' '}
                    {renderMuiTime('drug_time_hcg')} <span className={show ? 'show' : 'hide'}>{formData.drug_time_hcg}</span>{' '}
                  </>,
                  <>
                    {' '}
                    <input type='date' name='drug_date_hcg' value={formData.drug_date_hcg || ''} onChange={handleChange} className={!show ? 'show input createTime' : 'hide'} />{' '}
                    <span className={show ? 'show' : 'hide'}>{formData.drug_date_hcg}</span>{' '}
                  </>
                )}
              </tbody>
            </table>
            <div className='mt-2' style={{color: 'red', fontWeight: 'bold'}}>
              ⚠ IMPORTANT: Trigger timing is critical — do not delay or miss dose
            </div>
          </div>

          {/* OT/Embryology Team Table */}
          <div className='bulletin mt-4'>
            <h4 style={{fontWeight: 600}}>For OT/ embryology team</h4>
            {showOtTable && <TemplateTable id='ot' title='' headers={otHeaders} rows={otRows} onRowsChange={handleOtRowsChange} enableActions={true} onNill={handleNillOt} />}
          </div>

          {/* Pre-Operative Instructions */}
          <div className='bulletin mt-4'>
            <h4 style={{fontWeight: 600}}>Pre-Operative Instructions to the Patient</h4>
            <br />
            <ol>
              <li>
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <ReportFormInputWithLabel
                    label='Do not take any stimulation injections on the day before procedure on'
                    name='no_stim_date'
                    value={formData.no_stim_date}
                    onChange={handleChange}
                    type='date'
                    inputClassName='show'
                    styleLabel={{width: 'auto'}}
                    minWidth='600px'
                  />
                </div>
              </li>
              <li>
                <div style={{marginTop: '10px'}}>
                  <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd'}}>
                    <thead>
                      <tr>
                        <th style={{padding: '8px', border: '1px solid #ddd', backgroundColor: '#f9f9f9'}}>Test</th>
                        <th style={{padding: '8px', border: '1px solid #ddd', backgroundColor: '#f9f9f9'}}>Time</th>
                        <th style={{padding: '8px', border: '1px solid #ddd', backgroundColor: '#f9f9f9'}}>Date</th>
                        <th style={{padding: '8px', border: '1px solid #ddd', backgroundColor: '#f9f9f9'}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}>LH Kit (Ovulation Detection)</td>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}>{renderMuiTime('lh_kit_time')}</td>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}><input type='date' name='lh_kit_date' value={formData.lh_kit_date} onChange={handleChange} className='show' style={{border: 'none', outline: 'none'}} /></td>
                        <td style={{padding: '8px', border: '1px solid #ddd', fontSize: '12px'}}>Send photo via WhatsApp to your coordinator / DMO</td>
                      </tr>
                      <tr>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}>Urine Pregnancy Test</td>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}>{renderMuiTime('upt_time')}</td>
                        <td style={{padding: '8px', border: '1px solid #ddd'}}><input type='date' name='upt_date' value={formData.upt_date} onChange={handleChange} className='show' style={{border: 'none', outline: 'none'}} /></td>
                        <td style={{padding: '8px', border: '1px solid #ddd', fontSize: '12px'}}>Send photo via WhatsApp to your coordinator / DMO</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <li>Eat a soft diet at night – Idli, Idiyappam, or curd rice by 8:00 PM.</li>
              <li>Nothing by mouth (NPO) for 8 hours before the procedure FROM 12 MN</li>
              <li>Thyroid medication: Can be taken with a sip of water on empty stomach.</li>
              <li>Antihypertensive medications: Take only as advised.</li>
              <li>Diabetic medications: Do not take if fasting or on empty stomach.</li>
              <li>Personal Preparation: Remove nail polish, body hair (private parts), and all ornaments.</li>
              <li>Semen Collection: Ejaculate on the day of trigger; avoid intercourse.</li>
              <li>Documents Required: Bring Aadhar card of both husband and wife at admission.</li>
              <li>Financials: Pay the package fee as advised.</li>
            </ol>
          </div>

          <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
            <label htmlFor='additionalAdvice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
              ADVICE:
            </label>
            <textarea className='Textarea' placeholder='add advice' id='additionalAdvice' name='additionalAdvice' onChange={handleChange} rows='4' cols='100' />
          </div>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      <div id='eggCollectReportGenerate'>
        <div id='eggCollectReportGenerateWrap'>
          <Headers />
          <p className='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

          <div style={{display: 'block', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px', textAlign: 'center'}}>Instructions for Egg Collection – ASCAS</h4>
          </div>

          <div className='bulletin mt-2'>
            <h4 style={{fontWeight: 600}}>Admission Details:</h4>
            <div style={{display: 'flex', marginTop: '10px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              {renderReportfield('Date :', formData.admissiondate5?.split('-').reverse().join('-'))}
              {renderReportfield('Time :', formData.admissiontime5)}
              {renderReportfield('Place :', formData.admissionplace5)}
            </div>
            <div style={{display: 'flex', marginTop: '5px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              <span style={{fontWeight: '600'}}>Inform: Dr. Aishwarya Parthasarathy at the time of admission</span>
            </div>
          </div>

          <div className='bulletin mt-2'>
            <h4 style={{fontWeight: 600}}>Procedure Details:</h4>
            <div style={{display: 'flex', marginTop: '10px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              {renderReportfield('Date :', formData.proceduredate5?.split('-').reverse().join('-'))}
              {renderReportfield('Time :', formData.proceduretime5)}
            </div>
          </div>

          <div className='bulletin mt-2'>
            <h4 style={{fontWeight: 600}}>Stimulation Summary</h4>
            <div style={{display: 'flex', marginTop: '5px'}}>
              <span style={{fontWeight: '600'}}>Hormone Levels on Trigger Day:</span>
            </div>
            <div style={{display: 'flex', marginTop: '5px', flexWrap: 'wrap'}}>
              {renderReportfield('Trigger Date:', formatDisplayDate(getTriggerDate(formData)))}
            </div>
            <div style={{display: 'flex', marginTop: '5px', flexWrap: 'wrap'}}>
              {renderReportfield('E2:', formData.e25)} pg/ml
              {renderReportfield('LH:', formData.lh5)} mIU/mL
              {renderReportfield('P4:', formData.p45)} ng/ml
            </div>
          </div>

          {/* Report Table for Drugs */}
          <div className='bulletin mt-2'>
            <h4 style={{fontWeight: 600}}>Trigger Injection Details</h4>
            <table style={{borderCollapse: 'collapse', width: '100%', border: '1px solid black'}}>
              <thead>
                <tr>{['Drug', 'Generic Name', 'Dose', 'Route', 'Time', 'Date'].map(th => renderTableTH(th))}</tr>
              </thead>
              <tbody>
                <tr>
                  {renderTableTD('Inj. Ovitrelle')}
                  {renderTableTD('Choriogonadotropin alfa (recombinant hCG)')}
                  {renderTableTD('250 mcg')}
                  {renderTableTD('SC')}
                  {renderTableTD(formData.drug_time_15)}
                  {renderTableTD(formData.drug_date_15?.split('-').reverse().join('-'))}
                </tr>
                <tr>
                  {renderTableTD('Inj. Decapeptyl')}
                  {renderTableTD('Triptorelin (GnRH agonist)')}
                  {renderTableTD('0.2/0.3/0.4 mg')}
                  {renderTableTD('SC')}
                  {renderTableTD(formData.drug_time_25)}
                  {renderTableTD(formData.drug_date_25?.split('-').reverse().join('-'))}
                </tr>
                <tr>
                  {renderTableTD('T. Dulcolax')}
                  {renderTableTD('Bisacodyl')}
                  {renderTableTD('2 tabs')}
                  {renderTableTD('Oral')}
                  {renderTableTD('8:00 AM')}
                  {renderTableTD(formData.drug_date_dulcolux?.split('-').reverse().join('-'))}
                </tr>
                <tr>
                  {renderTableTD('T. Indocap')}
                  {renderTableTD('Indomethacin')}
                  {renderTableTD('1-0-1')}
                  {renderTableTD('Oral (after food)')}
                  {renderTableTD('9:00 AM – 9:00 PM')}
                  {renderTableTD(formData.drug_date_indocap?.split('-').reverse().join('-'))}
                </tr>
                <tr>
                  {renderTableTD('Tab. Pan 40')}
                  {renderTableTD('Pantoprazole')}
                  {renderTableTD('40 mg')}
                  {renderTableTD('Oral (before food)')}
                  {renderTableTD('1-0-1')}
                  {renderTableTD(formData.drug_date_pan?.split('-').reverse().join('-'))}
                </tr>
                <tr>
                  {renderTableTD('Inj. HCG')}
                  {renderTableTD('Human Chorionic Gonadotropin (urinary gonadotropin)')}
                  {renderTableTD('2000 / 5000 IU')}
                  {renderTableTD('IM / SC')}
                  {renderTableTD(formData.drug_time_hcg)}
                  {renderTableTD(formData.drug_date_hcg?.split('-').reverse().join('-'))}
                </tr>
              </tbody>
            </table>
            <div className='mt-2' style={{color: 'red', fontWeight: 'bold'}}>
              ⚠ IMPORTANT: Trigger timing is critical — do not delay or miss dose
            </div>
          </div>

          {showOtTable && (
            <div className='bulletin mt-2'>
              <h4 style={{fontWeight: 600}}>For OT / Embryology Team</h4>
              <table style={{borderCollapse: 'collapse', width: '100%'}}>
                <tbody>
                  <tr>
                    <td style={{width: '40%', fontWeight: '600', padding: '5px', border: '1px solid black'}}>New Added in IP List</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.newaddediplist5}</td>
                  </tr>
                  <tr>
                    <td style={{fontWeight: '600', padding: '5px', border: '1px solid black'}}>Informed Embryologist</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.informedembryologist5}</td>
                  </tr>
                  <tr>
                    <td style={{fontWeight: '600', padding: '5px', border: '1px solid black'}}>Informed Anesthesiologist</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.informedanesthesiologist5}</td>
                  </tr>
                  <tr>
                    <td style={{fontWeight: '600', padding: '5px', border: '1px solid black'}}>Type of Sperm</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.typeofsperm5}</td>
                  </tr>
                  <tr>
                    <td style={{fontWeight: '600', padding: '5px', border: '1px solid black'}}>Additional Procedure</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.additionalprocedure5}</td>
                  </tr>
                  <tr>
                    <td style={{fontWeight: '600', padding: '5px', border: '1px solid black'}}>Sperm Selection Technique</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.spermselectiontechnique5}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          <div className='bulletin mt-2'>
            <h4 style={{fontWeight: 600}}>Pre-Operative Instructions to the Patient</h4>
            <div style={{marginTop: '10px'}}>
              {renderReportfield('1. Do not take any stimulation injections on the day before procedure on', formData.no_stim_date?.split('-').reverse().join('-'))}
            </div>
            <div style={{marginTop: '5px'}}>
              <table style={{borderCollapse: 'collapse', width: '100%', border: '1px solid black'}}>
                <thead>
                  <tr>
                    <th style={{padding: '5px', border: '1px solid black', backgroundColor: '#f5f5f5'}}>Test</th>
                    <th style={{padding: '5px', border: '1px solid black', backgroundColor: '#f5f5f5'}}>Time</th>
                    <th style={{padding: '5px', border: '1px solid black', backgroundColor: '#f5f5f5'}}>Date</th>
                    <th style={{padding: '5px', border: '1px solid black', backgroundColor: '#f5f5f5'}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{padding: '5px', border: '1px solid black'}}>LH Kit (Ovulation Detection)</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.lh_kit_time}</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.lh_kit_date?.split('-').reverse().join('-')}</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>Send photo via WhatsApp to your coordinator / DMO</td>
                  </tr>
                  <tr>
                    <td style={{padding: '5px', border: '1px solid black'}}>Urine Pregnancy Test</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.upt_time}</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>{formData.upt_date?.split('-').reverse().join('-')}</td>
                    <td style={{padding: '5px', border: '1px solid black'}}>Send photo via WhatsApp to your coordinator / DMO</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {[
              '2. Eat a soft diet at night – Idli, Idiyappam, or curd rice by 8:00 PM.',
              '3. Nothing by mouth (NPO) for 8 hours before the procedure FROM 12 MN',
              '4. Thyroid medication: Can be taken with a sip of water on empty stomach.',
              '5. Antihypertensive medications: Take only as advised.',
              '6. Diabetic medications: Do not take if fasting or on empty stomach.',
              '7. Personal Preparation: Remove nail polish, body hair (private parts), and all ornaments.',
              '8. Semen Collection: Ejaculate on the day of trigger; avoid intercourse.',
              '9. Documents Required: Bring Aadhar card of both husband and wife at admission.',
              '10. Financials: Pay the package fee as advised.'
            ].map((ele, ind) => (
              <div style={{marginTop: '5px'}} key={ind}>
                {ele}
              </div>
            ))}
          </div>

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.additionalAdvice}</pre>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
